module.exports = __webpack_public_path__ + "static/media/straven_9.2f9c9258.jpg";